import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faStore } from '@fortawesome/free-solid-svg-icons';
import Select from '../Form/Fields/Select';
import InputPharmacy from '../Form/Fields/InputPharmacy';
import InputText from '../Form/Fields/InputText';
import { API_BASE_URL } from '../../api';
import '../Modal/CreateProductModal.scss';

const LANGUAGE_OPTIONS = [
  { value: 'ar', label: 'Arabe' },
  { value: 'en', label: 'Anglais' },
  { value: 'fr', label: 'Français' },
];

const AccountInformation = ({ user }) => {
  const { setValue } = useFormContext();
  const pharmacyId = user?.pharmacy?.id;

  // user.pharmacy's address fields come back null from /api/auth/me (lazy-loaded
  // collection, no open Hibernate session at that point — see PharmacyDTO), so the current
  // address is fetched fresh here instead, from the endpoint PharmacyDetails.js already
  // relies on for the same data, and pushed into the shared accountModalForm once loaded.
  useEffect(() => {
    if (!pharmacyId) return;
    axios.get(`${API_BASE_URL}/api/v1/pharmacies/${pharmacyId}`, { withCredentials: true })
      .then(({ data }) => {
        const addr = data.addresses?.[0];
        if (!addr) return;
        setValue('pharmacyAddress', addr.address || '');
        setValue('pharmacyAddress2', addr.address2 || '');
        setValue('pharmacyCity', addr.city || '');
        setValue('pharmacyPostalCode', addr.postalCode || '');
        setValue('pharmacyTelephone', addr.telephone || '');
      })
      .catch(() => {});
  }, [pharmacyId, setValue]);

  return (
    <div>
      <div className="account-modal__group-title">
        <FontAwesomeIcon icon={faUser} />
        Informations personnelles
      </div>

      <div className="cdm-grid-2">
        <div>
          <label className="cdm-field-label">Nom complet <span className="text-danger">*</span></label>
          <div className="input-group">
            <InputText name="firstName" placeholder="Prénom" validationRules={{ required: "Le prénom est obligatoire" }} />
            <InputText name="lastName" placeholder="Nom" validationRules={{ required: "Le nom est obligatoire" }} />
          </div>
        </div>
        <div>
          <label className="cdm-field-label">Email <span className="text-danger">*</span></label>
          <InputText name="email" placeholder="Email" validationRules={{ required: "L'email est obligatoire" }} />
        </div>
      </div>

      <div className="mt-3">
        <label className="cdm-field-label">Langue</label>
        <Select name="preferredLanguage" options={LANGUAGE_OPTIONS} />
      </div>

      <div className="account-modal__group-title">
        <FontAwesomeIcon icon={faStore} />
        Informations de la pharmacie
      </div>

      <div className="cdm-grid-2">
        <div>
          <label className="cdm-field-label">Pharmacie <span className="text-danger">*</span></label>
          <InputPharmacy
            name="pharmacyId"
            placeholder="Pharmacie"
            validationRules={{ required: "La pharmacie est obligatoire" }}
            disabled={true}
          />
        </div>
        <div>
          <label className="cdm-field-label">Téléphone de la pharmacie</label>
          <InputText name="pharmacyTelephone" placeholder="Téléphone" />
        </div>
      </div>

      <div className="cdm-grid-2 mt-3">
        <div>
          <label className="cdm-field-label">Adresse</label>
          <InputText name="pharmacyAddress" placeholder="Adresse" />
        </div>
        <div>
          <label className="cdm-field-label">Complément d'adresse</label>
          <InputText name="pharmacyAddress2" placeholder="Complément (optionnel)" />
        </div>
      </div>

      <div className="cdm-grid-2 mt-3">
        <div>
          <label className="cdm-field-label">Ville</label>
          <InputText name="pharmacyCity" placeholder="Ville" />
        </div>
        <div>
          <label className="cdm-field-label">Code postal</label>
          <InputText name="pharmacyPostalCode" placeholder="Code postal" />
        </div>
      </div>
    </div>
  );
};

export default AccountInformation;
